<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const currentQuestion = computed(() => store.getters.currentQuestion);
const inTransition = ref(false);

function respond(value) {
    if (inTransition.value) { return; }
    inTransition.value = true;

    return store.dispatch('questionResponse', {
        qindex: currentQuestion.value.index,
        response: value,
    });
}
</script>

<template>
    <div>
        <TransitionGroup
            tag="div"
            class="row flex-nowrap overflow-visible"
            name="animation-class"
            @after-leave="inTransition = false"
        >
            <div
                class="col-12"
                :key="currentQuestion.index"
            >
                <div class="row justify-content-center">
                    <div class="col-sm-6 mb-3">
                        <button
                            class="hover-invert p-4 choice"
                            @click="respond(-1)"
                        >
                            {{ currentQuestion.left }}
                        </button>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <button
                            class="hover-invert p-4 choice"
                            @click="respond(1)"
                        >
                            {{ currentQuestion.right }}
                        </button>
                    </div>
                </div>
            </div>
        </TransitionGroup>
        <div class="text-center">
            <div
                class="btn btn-secondary d-sm-inline-block d-block mb-5 mt-0 mb-sm-4 mt-sm-5"
                @click="respond(0)"
            >
                Spring over
            </div>
        </div>
    </div>
</template>
